import { render, staticRenderFns } from "./AdminAccounts.vue?vue&type=template&id=672f8bf4&"
import script from "./AdminAccounts.vue?vue&type=script&lang=js&"
export * from "./AdminAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports